const boxShadows = {
    normal: '0px 10px 25px -5px rgba(0,0,0,0.25)',
    hover: '0px 10px 25px -1px rgba(0,0,0,0.3)',
};

export default boxShadows;